import { dispatch } from "../store/store";
import {
  setUserData,
  setIsOnboardingVerificationLoading,
  getUserData,
  setImage,
  updateUserByUserEmailData,
  updateIsActiveByUserEmailData,
  updateIsVerifyByUserEmailData,
  updateIsActiveByUserEmailDataCode,
  getGphcNumberData,
  getEmailByInvitationCodeData,
  getUserForOrbitData,
  resendEmailToUserData,
  userChangePasswordData,
  setOrbitGPHCData,
  setLinkLoadingData,
  setProcessingAppData,
  setYotiStepsData,
  setEmailVerificationData,
  setSignupFormData,
  setOnboardingSuccessData,
  getUserCertificateData,
  acceptTermsAndConditionsData,
  getTermsAndConditionsPdfData,
  setTermsAcceptedData,
  getInviteMemberLogsData,
  reinviteEmailToUserData,
} from "../features/onboardingVerificationSlice/onboardingVerificationSlice";
import { downloadBase64File } from "../utils/downloadBase64File";

const reducerName = "onboardingVerification";

export const setUser = (data) => {
  dispatch(setUserData(data));
};
export const setProfileImage = ([profileImage]) => {
  dispatch(setImage(profileImage));
};
export const setOnboardingVerificationLoading = (isLoading) => {
  dispatch(setIsOnboardingVerificationLoading(isLoading));
};
export const setOrbitGPHC = (data) => {
  dispatch(setOrbitGPHCData(data));
};
export const setLinkLoading = (data) => {
  dispatch(setLinkLoadingData(data));
};
export const setProcessingApp = (data) => {
  dispatch(setProcessingAppData(data));
};
export const setYotiSteps = (data) => {
  dispatch(setYotiStepsData(data));
};
export const setEmailVerification = (data) => {
  dispatch(setEmailVerificationData(data));
};
export const setSignupForm = (data) => {
  dispatch(setSignupFormData(data));
};
export const setOnboardingSuccess = (data) => {
  dispatch(setOnboardingSuccessData(data));
};
export const setTermsAcceptedStatus = (status) => {
  dispatch(setTermsAcceptedData(status));
};

export const getUser = async (userEmail) => {
  let result = [];
  try {
    result = await dispatch(getUserData(userEmail)).unwrap();
  } catch (error) {
    result = [];
  }
  return result;
};

export const getEmailByInvitationCode = async (invitationCode) => {
  let result = [];
  try {
    result = await dispatch(
      getEmailByInvitationCodeData(invitationCode),
    ).unwrap();
  } catch (error) {
    result = [];
  }
  return result;
};
export const getInviteMemberLogs = async () => {
  let result = [];
  try {
    result = await dispatch(getInviteMemberLogsData()).unwrap();
  } catch (error) {
    result = [];
  }
  return result;
};
export const getUserForOrbit = async () => {
  let result = [];
  try {
    result = await dispatch(getUserForOrbitData()).unwrap();
  } catch (error) {
    result = [];
  }
  return result;
};
export const getGphcNumber = async (gphcNumber) => {
  let result = [];
  try {
    result = await dispatch(getGphcNumberData(gphcNumber)).unwrap();
  } catch (error) {
    result = [];
  }
  return result;
};

export const updateUserByUserEmail = async (userData, userEmail) => {
  let result = [];
  try {
    result = await dispatch(
      updateUserByUserEmailData({ userData, userEmail }),
    ).unwrap();
  } catch (error) {
    result = [];
  }
  return result;
};
export const resendEmailToUser = async (userEmail) => {
  let result = [];
  try {
    result = await dispatch(resendEmailToUserData(userEmail)).unwrap();
  } catch (error) {
    result = [];
  }
  return result;
};

export const reinviteEmailToUser = async (memberId) => {
  let result = [];
  try {
    result = await dispatch(reinviteEmailToUserData(memberId)).unwrap();
  } catch (error) {
    result = [];
  }
  return result;
};
export const userChangePassword = async (userEmail) => {
  let result = [];
  try {
    result = await dispatch(userChangePasswordData(userEmail)).unwrap();
  } catch (error) {
    result = [];
  }
  return result;
};

export const updateIsActiveByUserEmail = async (userEmail, code) => {
  let result = [];
  try {
    result = await dispatch(
      updateIsActiveByUserEmailData({ userEmail, code }),
    ).unwrap();
  } catch (error) {
    result = [];
  }
  return result;
};

export const updateIsActiveByUserEmailCode = async (code) => {
  let result = null;
  try {
    result = await dispatch(
      updateIsActiveByUserEmailDataCode({ code }),
    ).unwrap();
  } catch (error) {
    // Return the error payload or message
    result = error?.response?.data || error?.data || error?.message || error;
  }
  return result;
};

export const updateIsVerifyByUserEmail = async (userEmail, userData) => {
  let result = [];
  try {
    result = await dispatch(
      updateIsVerifyByUserEmailData({ userEmail, userData }),
    ).unwrap();
  } catch (error) {
    result = [];
  }
  return result;
};

export const getUserCertificate = async () => {
  let result = [];
  try {
    result = await dispatch(getUserCertificateData()).unwrap();
  } catch (error) {
    result = [];
  }
  return result;
};

export const acceptTerms = async (data) => {
  let result = null;
  try {
    result = await dispatch(acceptTermsAndConditionsData(data)).unwrap();
  } catch (error) {
    console.error("Error accepting terms:", error);
    result = null;
  }
  return result;
};

export const downloadTermsPdf = async (fileName) => {
  try {
    const result = await dispatch(
      getTermsAndConditionsPdfData(fileName),
    ).unwrap();
    const base64File = result?.fileContent;

    if (!base64File) {
      throw new Error("Base64 file not found");
    }

    downloadBase64File(base64File, fileName);
  } catch (error) {
    console.error("Error downloading terms file:", error);
  }
};
